module.exports = JSON.parse('{"Clear dates":"Tarihleri Temizle","End Date":"Bitiş Tarih","Start Date":"Başlangıç Tarihi"}')